/* Morning Friday — motion layer */
(function () {
  var doc = document.documentElement;
  doc.classList.add('mfx-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on view ---------- */
  function observe(root) {
    var els = (root || document).querySelectorAll('[data-reveal], .mfx-signpost, .mfx-picks');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- sunrise time ---------- */
  function sunrise() {
    var el = document.querySelector('[data-mf-sun]');
    if (!el || !window.Intl) return;
    function rise(y, m, d, lat, lon) {
      var r = Math.PI / 180, day = Math.round((Date.UTC(y, m, d) - Date.UTC(y, 0, 0)) / 864e5), g = 2 * Math.PI / 365 * (day - 1);
      var eq = 229.18 * (0.000075 + 0.001868 * Math.cos(g) - 0.032077 * Math.sin(g) - 0.014615 * Math.cos(2 * g) - 0.040849 * Math.sin(2 * g));
      var de = 0.006918 - 0.399912 * Math.cos(g) + 0.070257 * Math.sin(g) - 0.006758 * Math.cos(2 * g) + 0.000907 * Math.sin(2 * g) - 0.002697 * Math.cos(3 * g) + 0.00148 * Math.sin(3 * g);
      var ha = Math.acos(Math.cos(90.833 * r) / (Math.cos(lat * r) * Math.cos(de)) - Math.tan(lat * r) * Math.tan(de));
      return new Date(Date.UTC(y, m, d) + (720 - 4 * (lon + ha / r) - eq) * 6e4);
    }
    try {
      var tz = el.dataset.tz, p = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date(Date.now() + 864e5)).forEach(function (x) { if (x.type !== 'literal') p[x.type] = +x.value; });
      var s = rise(p.year, p.month - 1, p.day, +el.dataset.lat, +el.dataset.lon);
      el.querySelector('[data-mf-sun-time]').textContent = new Intl.DateTimeFormat(el.dataset.locale || 'en', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: tz }).format(s);
      el.hidden = false;
    } catch (e) {}
  }

  /* ---------- hero parallax ---------- */
  var hero, layers = [];
  function heroInit() {
    hero = document.querySelector('.mfx-hero');
    if (!hero || reduce) return;
    hero.querySelectorAll('[data-depth]').forEach(function (el) { layers.push({ el: el, d: parseFloat(el.dataset.depth) }); });
  }
  function heroTick(y) {
    if (!hero || !layers.length) return;
    var h = hero.offsetHeight;
    if (y > h) return;
    layers.forEach(function (l) { l.el.style.transform = 'translate3d(0,' + (y * l.d).toFixed(1) + 'px,0)'; });
  }

  /* ---------- trail: horizontal slider + path through waypoints ---------- */
  var trail = null;
  function buildPath(t) {
    var track = t.track, pins = track.querySelectorAll('.mfx-wp__pin i'), tb = track.getBoundingClientRect();
    var pts = [];
    pins.forEach(function (i) { var b = i.getBoundingClientRect(); pts.push([b.left - tb.left + b.width / 2, b.top - tb.top + b.height / 2]); });
    if (pts.length < 2) return;
    var pinXs = pts.map(function (p) { return p[0]; });
    pts.unshift([0, pts[0][1] + 60]);
    pts.push([tb.width, pts[pts.length - 1][1] - 40]);
    var d = 'M' + pts[0][0] + ' ' + pts[0][1];
    for (var k = 0; k < pts.length - 1; k++) {
      var p0 = pts[k - 1] || pts[k], p1 = pts[k], p2 = pts[k + 1], p3 = pts[k + 2] || p2;
      d += ' C' + (p1[0] + (p2[0] - p0[0]) / 6).toFixed(1) + ' ' + (p1[1] + (p2[1] - p0[1]) / 6).toFixed(1) + ',' + (p2[0] - (p3[0] - p1[0]) / 6).toFixed(1) + ' ' + (p2[1] - (p3[1] - p1[1]) / 6).toFixed(1) + ',' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
    }
    var svg = t.svg;
    svg.setAttribute('viewBox', '0 0 ' + tb.width + ' ' + tb.height);
    svg.querySelector('.mfx-trail__line').setAttribute('d', d);
    var walked = svg.querySelector('.mfx-trail__walked');
    walked.setAttribute('d', d);
    t.walked = walked;
    t.len = walked.getTotalLength();
    walked.style.strokeDasharray = t.len;
    if (!t.drawn) { walked.style.strokeDashoffset = t.len; t.drawn = true; }
    svg.querySelector('.mfx-trail__fill').setAttribute('d', d + ' L' + tb.width + ' ' + tb.height + ' L0 ' + tb.height + ' Z');
    /* path length at each waypoint (x grows monotonically along the path) */
    t.pinLens = pinXs.map(function (x) {
      var lo = 0, hi = t.len;
      for (var n = 0; n < 22; n++) { var mid = (lo + hi) / 2; if (walked.getPointAtLength(mid).x < x) lo = mid; else hi = mid; }
      return lo;
    });
  }
  function walkTo(len) {
    if (!trail || !trail.walked) return;
    trail.walked.style.strokeDashoffset = Math.max(0, trail.len - len).toFixed(1);
  }
  function setActive(i) {
    if (!trail) return;
    trail.cards.forEach(function (c, n) { c.classList.toggle('is-active', n === i); c.classList.toggle('is-passed', n < i); });
  }
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  function maxScroll() { return Math.max(0, trail.vp.scrollWidth - trail.vp.clientWidth); }
  function trailInit() {
    var el = document.querySelector('.mfx-trail');
    if (!el) return;
    trail = { el: el, track: el.querySelector('.mfx-trail__track'), svg: el.querySelector('.mfx-trail__profile'), bar: el.querySelector('.mfx-trail__progress'), vp: el.querySelector('.mfx-trail__viewport'), hover: null, active: 0, dragging: false };
    trail.cards = Array.prototype.slice.call(el.querySelectorAll('.mfx-wp'));
    trail.cards.forEach(function (c, i) {
      c.addEventListener('mouseenter', function () { if (!canHover.matches || trail.dragging || !trail.pinLens) return; trail.hover = i; setActive(i); walkTo(trail.pinLens[i] + 2); });
      c.addEventListener('mouseleave', function () { if (trail.hover === null) return; trail.hover = null; trailTick(); });
    });
    el.querySelectorAll('[data-trail-step]').forEach(function (b) {
      b.addEventListener('click', function () { step(+b.dataset.trailStep); });
    });
    el.querySelectorAll('.mfx-trail__track img, .mfx-trail__track a').forEach(function (n) { n.setAttribute('draggable', 'false'); });
    trail.vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    dragInit();
    scrubInit();
    trail.vp.setAttribute('tabindex', '0');
    trail.vp.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });
    trailLayout();
  }
  /* settle on the nearest card so nothing is left cut off at the edge (desktop) */
  function snapNearest(push) {
    if (!wide()) return;
    var vp = trail.vp, pad = parseFloat(getComputedStyle(trail.track).paddingLeft) || 0, max = maxScroll();
    var cw = trail.cards.length ? trail.cards[0].offsetWidth * 0.6 : 200;
    var target = vp.scrollLeft + Math.max(-cw, Math.min(cw, push || 0)), best = 0, bestD = Infinity;
    var stops = trail.cards.map(function (c) { return Math.max(0, Math.min(max, c.offsetLeft - pad)); });
    stops.push(max);
    stops.forEach(function (x) { var d = Math.abs(x - target); if (d < bestD) { bestD = d; best = x; } });
    vp.classList.add('is-settling');
    vp.scrollTo({ left: best, behavior: reduce ? 'auto' : 'smooth' });
    clearTimeout(trail.settle);
    trail.settle = setTimeout(function () { vp.classList.remove('is-settling'); }, 700);
  }
  /* mouse: click-and-drag the route like a slider, then settle on a card */
  function dragInit() {
    var vp = trail.vp, startX = 0, startLeft = 0, lastX = 0, lastT = 0, v = 0, moved = 0, id = null;
    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('button, select, input')) return;
      id = e.pointerId; startX = lastX = e.clientX; startLeft = vp.scrollLeft; lastT = performance.now(); v = 0; moved = 0;
      trail.dragging = true; trail.hover = null;
      vp.classList.add('is-grabbing');
    });
    window.addEventListener('pointermove', function (e) {
      if (!trail.dragging || e.pointerId !== id) return;
      var dx = e.clientX - startX, now = performance.now();
      moved = Math.max(moved, Math.abs(dx));
      if (moved > 4 && !vp.hasPointerCapture(id)) { try { vp.setPointerCapture(id); } catch (err) {} }
      vp.scrollLeft = startLeft - dx;
      var dt = Math.max(1, now - lastT);
      v = 0.8 * ((lastX - e.clientX) / dt) + 0.2 * v;
      lastX = e.clientX; lastT = now;
    });
    function end(e) {
      if (!trail.dragging || (e && e.pointerId !== id)) return;
      trail.dragging = false;
      vp.classList.add('is-settling');
      vp.classList.remove('is-grabbing');
      if (performance.now() - lastT > 80) v = 0;
      snapNearest(v * 260);
    }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    vp.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
  }
  /* the progress bar is a scrubber: click or drag it to travel the whole route */
  function scrubInit() {
    var bar = trail.bar; if (!bar) return;
    var on = false;
    function go(e) {
      var r = bar.getBoundingClientRect(), q = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      trail.vp.scrollLeft = q * maxScroll();
    }
    bar.addEventListener('pointerdown', function (e) { on = true; trail.vp.classList.add('is-grabbing'); try { bar.setPointerCapture(e.pointerId); } catch (err) {} go(e); e.preventDefault(); });
    bar.addEventListener('pointermove', function (e) { if (on) go(e); });
    function stop() { if (!on) return; on = false; trail.vp.classList.add('is-settling'); trail.vp.classList.remove('is-grabbing'); snapNearest(0); }
    bar.addEventListener('pointerup', stop);
    bar.addEventListener('pointercancel', stop);
    bar.setAttribute('role', 'slider');
    bar.setAttribute('aria-valuemin', '0');
    bar.setAttribute('aria-valuemax', '100');
  }
  function step(dir) {
    if (!trail) return;
    var next = Math.max(0, Math.min(trail.cards.length - 1, trail.active + dir));
    if (next === trail.active && dir > 0) { trail.vp.scrollTo({ left: maxScroll(), behavior: reduce ? 'auto' : 'smooth' }); return; }
    var card = trail.cards[next];
    var pad = parseFloat(getComputedStyle(trail.track).paddingLeft) || 0;
    var left = next === 0 ? 0 : (wide() ? card.offsetLeft - pad : card.offsetLeft - (trail.vp.clientWidth - card.offsetWidth) * 0.5);
    trail.vp.scrollTo({ left: Math.max(0, Math.min(maxScroll(), left)), behavior: reduce ? 'auto' : 'smooth' });
  }
  function wide() { return window.innerWidth >= 990; }
  function trailLayout() {
    if (!trail) return;
    trail.pinned = false;
    trail.el.classList.remove('is-pinned');
    trail.el.style.height = '';
    trail.track.style.transform = '';
    /* desktop: leave room after the last card so every stop starts cleanly at the left margin (no half-cut card) */
    trail.track.style.paddingRight = '';
    if (wide() && trail.cards.length) {
      var pad = parseFloat(getComputedStyle(trail.track).paddingLeft) || 0, last = trail.cards[trail.cards.length - 1];
      var extra = (trail.vp.clientWidth - pad) - (trail.track.scrollWidth - last.offsetLeft);
      if (extra > 0) trail.track.style.paddingRight = (pad + extra) + 'px';
    }
    buildPath(trail);
    trailTick();
  }
  function trailTick() {
    if (!trail || !trail.pinLens) return;
    var vp = trail.vp, max = maxScroll();
    var p = max > 0 ? vp.scrollLeft / max : 1;
    if (trail.bar) { trail.bar.style.setProperty('--p', p.toFixed(4)); trail.bar.setAttribute('aria-valuenow', Math.round(p * 100)); }
    /* active waypoint: first card at the start, last at the end, otherwise the one in reading position */
    var best = 0, bestD = Infinity;
    if (wide()) {
      /* desktop: the card sitting at the left margin */
      var pad = parseFloat(getComputedStyle(trail.track).paddingLeft) || 0;
      trail.cards.forEach(function (c, i) { var dd = Math.abs(c.offsetLeft - pad - vp.scrollLeft); if (dd < bestD) { bestD = dd; best = i; } });
    } else {
      var anchor = vp.scrollLeft + vp.clientWidth * 0.5;
      trail.cards.forEach(function (c, i) { var m = c.offsetLeft + c.offsetWidth / 2, dd = Math.abs(m - anchor); if (dd < bestD) { bestD = dd; best = i; } });
    }
    if (vp.scrollLeft < 8) best = 0;
    if (p > 0.985) best = trail.cards.length - 1;
    trail.active = best;
    if (trail.hover !== null) return;
    setActive(best);
    walkTo(p > 0.985 ? trail.len : trail.pinLens[best] + 2);
  }

  /* ---------- quick add (size chips on trail cards) ---------- */
  function quickAdd() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-quick-add]');
      if (!b || b.disabled) return;
      e.preventDefault();
      var box = b.closest('.mfx-wp__buy');
      b.setAttribute('aria-busy', 'true');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.quickAdd, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          b.removeAttribute('aria-busy');
          box.classList.add('is-added');
          b.classList.add('is-picked');
          var msg = box.querySelector('[data-added-msg]'), dm = box.querySelector('[data-default-msg]'); if (msg) msg.hidden = false; if (dm) dm.hidden = true;
          setTimeout(function () { box.classList.remove('is-added'); b.classList.remove('is-picked'); if (msg) msg.hidden = true; if (dm) dm.hidden = false; }, 2600);
          var icon = document.querySelector('cart-icon');
          if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
          if (window.MFXPack && typeof window.MFXPack.open === 'function') setTimeout(function () { window.MFXPack.open(); }, 450);
        })
        .catch(function () { b.removeAttribute('aria-busy'); box.classList.add('is-error'); setTimeout(function () { box.classList.remove('is-error'); }, 2400); });
    });
  }

  /* ---------- colour dots on trail cards: show that colour, link to it, filter sizes ---------- */
  function colourDots() {
    document.addEventListener('click', function (e) {
      var dot = e.target.closest('.mfx-wp__dot');
      if (!dot) return;
      e.preventDefault();
      var card = dot.closest('.mfx-wp'); if (!card) return;
      card.querySelectorAll('.mfx-wp__dot').forEach(function (d) { d.setAttribute('aria-pressed', d === dot ? 'true' : 'false'); });
      var img = card.querySelector('.mfx-wp__img img');
      if (img && dot.dataset.img) {
        img.removeAttribute('srcset');
        img.src = dot.dataset.img;
        img.classList.remove('is-swapping'); void img.offsetWidth; img.classList.add('is-swapping');
        card.classList.add('is-coloured');
      }
      var link = card.querySelector('.mfx-wp__link');
      if (link && dot.dataset.href) link.href = dot.dataset.href;
      var colour = dot.dataset.colour;
      card.querySelectorAll('.mfx-size[data-colour]').forEach(function (b) { b.hidden = b.dataset.colour !== colour; });
    });
  }

  /* ---------- hotspots ---------- */
  function hotspots() {
    document.querySelectorAll('.mfx-hot button').forEach(function (b) {
      b.addEventListener('click', function () {
        var h = b.parentNode, open = !h.classList.contains('is-open');
        document.querySelectorAll('.mfx-hot.is-open').forEach(function (o) { o.classList.remove('is-open'); });
        h.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open);
      });
    });
  }

  /* ---------- fit display text to its container ---------- */
  function fit() {
    document.querySelectorAll('[data-fit]').forEach(function (box) {
      var max = parseFloat(box.dataset.fit) || 400;
      var cs = getComputedStyle(box), avail = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      box.querySelectorAll('[data-fit-line]').forEach(function (line) {
        line.style.fontSize = '100px';
        var m = line.querySelector('[data-fit-measure]') || line;
        var w = m.getBoundingClientRect().width || 1;
        line.style.fontSize = Math.min(max, Math.floor(100 * avail / w * 0.98)) + 'px';
      });
    });
  }

  /* ---------- loop ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { heroTick(window.scrollY); trailTick(); ticking = false; });
  }
  function init() {
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(); trailLayout(); });
    observe();
    sunrise();
    heroInit();
    trailInit();
    hotspots();
    quickAdd();
    colourDots();
    window.addEventListener('scroll', onScroll, { passive: true });
    var vp = document.querySelector('.mfx-trail__viewport');
    if (vp) vp.addEventListener('scroll', onScroll, { passive: true });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { fit(); trailLayout(); }, 150); });
    window.addEventListener('load', trailLayout);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
